import { useState } from "react";
import { Play, Loader2 } from "lucide-react";
import { apiResponse, UI } from "./profileData";

const colorize = (json) =>
  json.split("\n").map((line, i) => {
    const m = line.match(/^(\s*)("[^"]+")(:\s*)(.*)$/);
    if (!m) return <div key={i} className="text-slate-400">{line}</div>;
    const [, sp, key, colon, val] = m;
    const valCls = val.startsWith('"') ? "text-emerald-300" : /^(true|false|\d)/.test(val) ? "text-[#FF7A33]" : "text-slate-400";
    return (
      <div key={i}>
        {sp}<span className="text-sky-300">{key}</span><span className="text-slate-500">{colon}</span>
        <span className={valCls}>{val}</span>
      </div>
    );
  });

export const ApiTerminal = ({ lang }) => {
  const t = UI[lang];
  const [state, setState] = useState("idle");
  const [ms, setMs] = useState(0);

  const send = () => {
    setState("loading");
    const t = 180 + Math.floor(Math.random() * 120);
    setTimeout(() => { setMs(t); setState("done"); }, 700);
  };

  return (
    <section className="py-12" data-testid="api-terminal-section">
      <p className="mb-4 font-mono text-xs uppercase tracking-widest text-slate-500">// live api</p>
      <div className="overflow-hidden rounded-xl border border-white/10 bg-[#050f1f] shadow-2xl shadow-black/40" data-testid="api-terminal">
        <div className="flex items-center gap-2 border-b border-white/10 bg-[#0b2240] px-4 py-3">
          <span className="h-3 w-3 rounded-full bg-red-500/80" />
          <span className="h-3 w-3 rounded-full bg-yellow-400/80" />
          <span className="h-3 w-3 rounded-full bg-emerald-500/80" />
          <span className="ml-3 font-mono text-xs text-slate-400">developer-api — terminal</span>
        </div>
        <div className="flex flex-col gap-3 border-b border-white/10 p-4 sm:flex-row sm:items-center">
          <div className="flex flex-1 items-center gap-3 rounded-md bg-white/5 px-3 py-2 font-mono text-sm">
            <span className="font-bold text-emerald-400">GET</span>
            <span className="truncate text-slate-200">/v1/developer/profile</span>
          </div>
          <button
            onClick={send}
            disabled={state === "loading"}
            className="inline-flex items-center justify-center gap-2 rounded-md bg-[#FF5500] px-5 py-2 font-mono text-sm font-semibold text-white transition-colors duration-200 hover:bg-[#ff6a1f] disabled:opacity-60"
            data-testid="api-send-btn"
          >
            {state === "loading" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Play className="h-4 w-4" />}
            Send
          </button>
        </div>
        <div className="min-h-[260px] p-4 font-mono text-xs leading-relaxed sm:text-sm" data-testid="api-response">
          {state === "idle" && (
            <p className="cursor-blink text-slate-500">{t.terminalIdle}</p>
          )}
          {state === "loading" && <p className="text-slate-400">{t.terminalLoading}</p>}
          {state === "done" && (
            <>
              <p className="mb-3 text-xs" data-testid="api-status">
                <span className="text-emerald-400">200 OK</span>
                <span className="ml-3 text-slate-500">{ms} ms · application/json</span>
              </p>
              <pre className="overflow-x-auto whitespace-pre">{colorize(JSON.stringify(apiResponse(lang), null, 2))}</pre>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default ApiTerminal;
